module.exports = "<app-accountmaster-menu></app-accountmaster-menu>\n<p>\n  gs-ga-creation works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/gs-ga-creation/gs-ga-creation.component.html
// module id = ./src/app/accountmaster/gs-ga-creation/gs-ga-creation.component.html
// module chunks = main